function setPropertyVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}

function setPropertyScrollbarWidth() {
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    scrollbarWidth = scrollbarWidth < 0 ? 0 : scrollbarWidth;

    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

function setPropertyStickyHeaderHeight() {
    const header = document.querySelector('.sticky-header');

    if (!header) {
        return;
    }

    document.documentElement.style.setProperty('--sticky-header-height', `${header.getBoundingClientRect().height}px`);
}

export default function () {
    window.addEventListener('resize', () => {
        setPropertyVh()
        setPropertyScrollbarWidth()
        setPropertyStickyHeaderHeight()
    });

    window.addEventListener('headerResize', setPropertyStickyHeaderHeight);

    setPropertyVh();
    setPropertyScrollbarWidth();
    setPropertyStickyHeaderHeight();
}
